module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_8004.35266885.png";